import React, { ChangeEvent } from 'react';
import { Grid, GridProps, TextField, TextFieldProps } from '@material-ui/core';

export type AddressFields = {
  address1: string;
  address2: string;
  city: string;
  postalCode: string;
  region: string;
  country: string;
};

export type ForeignAddressFieldProps = {
  ContainerComponentProps?: GridProps;
  Address1Props?: TextFieldProps;
  Address2Props?: TextFieldProps;
  CityProps?: TextFieldProps;
  PostalCodeProps?: TextFieldProps;
  RegionProps?: TextFieldProps;
  CountryProps?: TextFieldProps;
  value?: AddressFields;
  onChange?: (value: AddressFields) => void;
};

export const ForeignAddressField = ({
  onChange = () => undefined,
  ContainerComponentProps,
  value: valueProp = {
    address1: '',
    address2: '',
    city: '',
    postalCode: '',
    region: '',
    country: '',
  },
  Address1Props = {
    name: 'address1',
    label: 'Address 1',
  },
  Address2Props = {
    name: 'address2',
    label: 'Address 2',
  },
  CityProps = {
    name: 'city',
    label: 'City',
  },
  PostalCodeProps = {
    name: 'postalCode',
    label: 'Postal Code',
  },
  RegionProps = {
    name: 'region',
    label: 'Region',
  },
  CountryProps = {
    name: 'country',
    label: 'Country',
  },
}: ForeignAddressFieldProps): JSX.Element => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onChange({ ...valueProp, [name]: value });
  };

  return (
    <Grid container {...ContainerComponentProps}>
      <Grid container item xs={6}>
        <Grid item xs={12}>
          <TextField fullWidth {...Address1Props} onChange={handleChange} value={valueProp.address1} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth {...CityProps} onChange={handleChange} value={valueProp.city} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth {...RegionProps} onChange={handleChange} value={valueProp.region} />
        </Grid>
      </Grid>
      <Grid container item xs={6}>
        <Grid item xs={12}>
          <TextField fullWidth {...Address2Props} onChange={handleChange} value={valueProp.address2} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth {...PostalCodeProps} onChange={handleChange} value={valueProp.postalCode} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth {...CountryProps} onChange={handleChange} value={valueProp.country} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ForeignAddressField;
